import { setSpecificMessage, minValue } from "valibot";
setSpecificMessage(
  minValue,
  (issue) => `Valeur invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);